// extracted by mini-css-extract-plugin
export default {"landingpageFooter":"styles_landingpageFooter__ARzzC"};